<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="octo"
    viewBox="0 0 100 100"
    aria-labelledby="octoDesc"
  >
    <desc id="octoDesc">
      A green one-eyed octopus, smiling and swimming around with his little
      tentacles
    </desc>
    <g class="octo-octo">
      <path
        class="octo-arm-6"
        fill="none"
        stroke="#00c7c7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="8.301"
      >
        <animate
          dur="1.01s"
          repeatCount="indefinite"
          attributeName="d"
          values="M27.4 44s6.3 13.4 14 1.8;
                 M27.4 77.2s6.3-19.8 14-31.4;
                 M27.4 44s6.3 13.4 14 1.8;"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                 0.455 0.03 0.515 0.955"
        />
      </path>
      <path
        class="octo-arm-5"
        fill="none"
        stroke="#00c7c7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="8.301"
      >
        <animate
          dur="1s"
          repeatCount="indefinite"
          attributeName="d"
          values="M27.4 50.8s9.3 11.4 17.6-.9;
                 M32.1 86.8s4.5-24.6 12.8-36.9;
                 M27.4 50.8s9.3 11.4 17.6-.9;"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                 0.455 0.03 0.515 0.955"
        />
      </path>
      <path
        class="octo-arm-4"
        fill="none"
        stroke="#00c7c7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="8.301"
      >
        <animate
          dur="1.02s"
          repeatCount="indefinite"
          attributeName="d"
          values="M34.2 56.9s10.5 9.2 14.6-4.7;
                 M40.3 92.7s4.4-26.6 8.6-40.5;
                 M34.2 56.9s10.5 9.2 14.6-4.7;"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                 0.455 0.03 0.515 0.955"
        />
      </path>
      <path
        class="octo-arm-3"
        fill="none"
        stroke="#00c7c7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="8.301"
      >
        <animate
          dur=".99s"
          repeatCount="indefinite"
          attributeName="d"
          values="M72.8 51.9s-11.4 10.8-14.7-2.7;
                 M62.6 86.8s-1.2-24.1-4.5-37.6;
                 M72.8 51.9s-11.4 10.8-14.7-2.7"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                 0.455 0.03 0.515 0.955"
        />
      </path>
      <path
        class="octo-arm-2"
        fill="none"
        stroke="#00c7c7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="8.301"
      >
        <animate
          dur="1s"
          repeatCount="indefinite"
          attributeName="d"
          values="M68.7 57.5s-11.6 8.8-15.4-5.6;
                 M57 92.7s.1-26.4-3.7-40.8;
                 M68.7 57.5s-11.6 8.8-15.4-5.6;"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                 0.455 0.03 0.515 0.955"
        />
      </path>
      <path
        class="octo-arm-1"
        fill="none"
        stroke="#00c7c7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="8.301"
      >
        <animate
          dur="1.03s"
          repeatCount="indefinite"
          attributeName="d"
          values="M58.7 65.5s-9.9 9.3-9.9-12.7;
                 M47.8 93.9s1.1-19.1 1.1-41.1;
                 M58.7 65.5s-9.9 9.3-9.9-12.7;"
          calcMode="spline"
          keySplines="0.455 0.03 0.515 0.955;
                 0.455 0.03 0.515 0.955"
        />
      </path>
      <g class="octo-head">
        <ellipse
          cx="54.1"
          cy="31.9"
          fill="#00c7c7"
          rx="25.7"
          ry="23.6"
          transform="rotate(-78.217 54.138 31.903)"
        />
        <path
          fill="none"
          stroke="#004e88"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.038"
          d="M60.2 45.3c-.7 3.3-5 5.3-9.5 4.3-4.6-.9-7.7-4.5-7.1-7.8"
        />
        <g class="octo-eye">
          <ellipse
            cx="54.5"
            cy="30.6"
            fill="#fff"
            rx="12.2"
            ry="11.7"
            transform="rotate(-78.217 54.504 30.64)"
          />
          <ellipse
            cx="54.5"
            cy="30.9"
            fill="#003456"
            rx="4.5"
            ry="4.3"
            transform="rotate(-78.217 54.49 30.873)"
          />
          <ellipse cx="57" cy="29.9" fill="#fff" rx="1.1" ry="1.1" />
        </g>
      </g>
    </g>
  </svg>
</template>
